var appMiddleware = function (dispatch) { return function (next, done) { return function (message) {
    if (message.domain !== 'app') {
        return next(message);
    }
    switch (message.eventType) {
        case 'online_status':
            dispatch({
                purpose: 'response',
                request_id: message.data.request_id,
                response_data: { status: navigator.onLine },
            });
            done();
            break;
        case 'user_location':
            navigator.geolocation.getCurrentPosition(function (loc) {
                return dispatch({
                    purpose: 'response',
                    request_id: message.data.request_id,
                    response_data: {
                        type: 'fine',
                        location: {
                            latitude: loc.coords.latitude,
                            longitude: loc.coords.longitude,
                            accuracy: loc.coords.accuracy,
                        },
                    },
                });
            });
            done();
            break;
        case 'reset':
            history.pushState({}, '', '/#/');
            location.reload(true);
            done();
            break;
        // @TODO Need to dispatch an event back?
        default:
            console.warn('Unhandled app domain event', message);
            return next(message);
    }
}; }; };
export default appMiddleware;
//# sourceMappingURL=app.js.map